module.exports = __webpack_public_path__ + "img/instructions5.b51c0a9c.png";